import { Box, useTheme } from "@mui/material";
import BaseCard from "../../../theme/cards/BaseCard";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import Text from "../../../theme/text/Text";
import { getIntegratorLogo, getWebshopLogo } from "../../../../utils/logomapper";
import TopRight from "../../../theme/positionals/TopRight";
import CardLabel from "../../../theme/label/CardLabel";
import { useTranslation } from "react-i18next";

export const SalesChannelIntegratorCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const webshopLogo = getIntegratorLogo(props.type);

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick ? props.onClick : null}>
            <Box>
                <Box
                >
                    {props.skeleton ?
                        <ShDoubleTextSkeleton/> 
                        :
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                gap:2,  
                            }}
                        >
                            {webshopLogo ?? null}
                            <Box
                                sx={{
                                    display:"flex",
                                    flexDirection:"column",
                                }}
                            >
                                <Text bold >{props.name}</Text>
                                <Text >{props.integrator?.name}</Text>
                            </Box>
                        </Box>
                    }
                </Box>
                <TopRight>
                    <CardLabel variant={props.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey"}>
                        {t(props.state)}    
                    </CardLabel>
                </TopRight>
            </Box>
        </BaseCard>
    )
}

export const WarehouseIntegratorCard = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const webshopLogo = getIntegratorLogo(props.type);

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick ? props.onClick : null}>
            <Box>
                <Box
                >
                    {props.skeleton ?
                        <ShDoubleTextSkeleton/> 
                        :
                        <Box
                            sx={{
                                display:"flex",
                                alignItems:"center",
                                gap:2,  
                            }}
                        >
                            {webshopLogo ?? null}
                            <Box
                                sx={{
                                    display:"flex",
                                    flexDirection:"column",
                                }}
                            >
                                <Text bold >{props.name}</Text>
                                <Text>{props.webshopcredentials.length ?? 0} {t("channels")}</Text>
                            </Box>
                        </Box>
                    }
                </Box>
                <TopRight>
                    <CardLabel variant={props.state === "active" ? "green" : theme.palette.mode === "dark" ? "greyLight" : "grey"}>
                        {t(props.state)}    
                    </CardLabel>
                </TopRight>
            </Box>
        </BaseCard>
    )
}
